import axios, {AxiosError, AxiosRequestConfig, AxiosResponse} from "axios";
import {API_URL} from "../config";
import storage from "../utils/storage";

const authRequestInterceptor = (config: AxiosRequestConfig) => {
  const token = storage.getToken() || JSON.parse(sessionStorage.getItem("conectadoc_partner_token") as string) || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzaWQiOiI2NzQ2MTAiLCJlbWFpbCI6ImZhYmlhbm8ucm9zaW5AY29uZWN0YWRvYy5jb20uYnIiLCJleHAiOjE2NTg5NDM4NjAsImlzcyI6Iklzc3VlciIsImF1ZCI6ImF1ZGllbmNlIn0.622aTSSlSlpX_w3x0t2v5Ts6j4U1moM12wsAAuuRq6k";
  const isApiUrl = config.baseURL?.startsWith(API_URL);

  if (!config.headers) {
    config.headers = {};
  }

  if (token && isApiUrl) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  config.headers.Accept = "application/json";
  return config;
};

export const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use(authRequestInterceptor);